import * as React from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import useProductName from "brand-customization/useProductName";
import { Alert } from "components/bootstrap";
const StyledAlert = styled(Alert)(
  () => css`
    margin-top: 0;
  `
);
const RepositoryAccessInfo = () => {
  const productName = useProductName();
  const { t } = useTranslation("enterprise_data_tiering");
  return /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "info", title: t("repository_access.title") }, t("repository_access.body", { productName }));
};
export default RepositoryAccessInfo;
